<template>
  <b-overlay
      :show="showOverlay"
      rounded="sm"
  >
    <b-modal
        id="modal-Editor"
        centered
        ok-only
        ok-title="ثبت"
        title="افزودن کد HTML"
        @ok.prevent="customButtonClick"
    >
      <b-row>
        <b-col cols="12">
          <span class="d-block mb-1">
            کد HTML خود را در اینجا قرار دهید
          </span>

          <b-form-textarea
              v-model="rawHTML"
              rows="10"
              dir="ltr"
          />
        </b-col>
      </b-row>
    </b-modal>

    <component :is="product === null ? 'div' : 'b-card'">
      <b-tabs v-if="product !== null">
        <b-tab active>
          <template #title>
            <feather-icon
                class="mr-0 mr-sm-50"
                icon="ClipboardIcon"
                size="16"
            />

            <span class="d-none d-sm-inline">
              اطلاعات محصول
            </span>
          </template>

          <TagPicker v-model="product.tagIds" label="تگ‌های کارت دوره" />
          <TagPicker v-model="product.sliderTagIds" label="تگ‌های اسلایدر بالای صفحه" />

          <b-media class="my-2">
            <template>
              <b-avatar
                  ref="previewEl"
                  :src="base64ImageSrc"
                  rounded
                  size="300px"
              />
            </template>

            <div class="d-flex flex-wrap mt-1">
              <b-button
                  variant="primary"
                  @click="$refs.refInputEl.click()"
              >
                <input
                    ref="refInputEl"
                    class="d-none"
                    type="file"
                    accept="image/*"
                    @change="makeBase64Pic"
                >

                <span class="d-none d-sm-inline">
                  + عکس
                </span>

                <feather-icon
                    class="d-inline d-sm-none"
                    icon="EditIcon"
                />
              </b-button>

              <b-button
                  class="ml-1"
                  variant="outline-secondary"
                  @click="deleteProductPic"
              >
                <span class="d-none d-sm-inline">
                  حذف
                </span>

                <feather-icon
                    class="d-inline d-sm-none"
                    icon="TrashIcon"
                />
              </b-button>
            </div>
          </b-media>

          <b-form @submit.prevent="updateProduct">
            <b-row>
              <b-col
                  cols="12"
                  md="4"
              >
                <b-form-group
                    label="عنوان"
                    label-for="Title"
                >
                  <b-form-input
                      id="Title"
                      v-model="product.title"
                  />
                </b-form-group>
              </b-col>

              <b-col
                  cols="12"
                  md="4"
              >
                <b-form-group
                    label="وضعیت"
                    label-for="isFree"
                >
                  <v-select
                      v-model="product.isFree"
                      :clearable="false"
                      :options="isFreeOptions"
                      :reduce="item => item.value"
                      input-id="isFree"
                      label="label"
                  />
                </b-form-group>
              </b-col>

              <b-col
                  v-if="!product.isFree"
                  cols="12"
                  md="4"
              >
                <b-form-group
                    label="قیمت (تومان)"
                    label-for="price"
                >
                  <b-form-input
                      id="price"
                      v-model="product.price"
                      type="number"
                      min="0"
                  />
                </b-form-group>
              </b-col>

              <b-col
                  cols="12"
                  md="4"
              >
                <b-form-group
                    label="قیمت قبلی (خط خورده)"
                    label-for="beforeDiscount"
                >
                  <b-form-input
                      id="beforeDiscount"
                      v-model="product.beforeDiscount"
                      type="number"
                      min="0"
                  />
                </b-form-group>
              </b-col>

              <b-col
                  cols="12"
                  md="4"
              >
                <div class="product-categories mt-2">
                  <span class="filter-title">
                    نمایش محصول در باندل
                  </span>

                  <b-form-checkbox
                      v-model="product.showOnlyInBundle"
                      inline
                      name="showOnlyInBundle"
                      switch
                  />
                </div>
              </b-col>

              <b-col cols="12">
                <b-form-group
                    label="سوتیتر"
                    label-for="subtitle"
                >
                  <b-form-input
                      id="subtitle"
                      v-model="product.subtitle"
                  />
                </b-form-group>
              </b-col>


              <b-col cols="12">
                <b-form-group
                    class="mb-2"
                    label="توضیحات"
                    label-for="product-content"
                >
                  <ckEditorMain
                      ref="editorContent"
                      :defaultContent="product.description"
                      @getEditorContent="setEditorContent"
                  />
                </b-form-group>

                <b-form-textarea
                    v-if="showHTML"
                    id="product-content"
                    v-model="rawHTML"
                    class="mb-2"
                    rows="10"
                    dir="ltr"
                />
              </b-col>

              <b-col
                  v-if="categories !== null"
                  cols="12"
                  md="4"
              >
                <b-form-group
                    label="دسته‌بندی محصول"
                    label-for="productCategoryId"
                >
                  <v-select
                      v-model="product.productCategoryId"
                      :clearable="false"
                      :options="categories"
                      :reduce="item => item.productCategoryId"
                      disabled
                      input-id="productCategoryId"
                      label="name"
                  />
                </b-form-group>
              </b-col>

              <b-col
                  cols="12"
                  md="4"
              >
                <b-form-group
                    label="نوع محصول"
                    label-for="productType"
                >
                  <v-select
                      v-model="product.type"
                      :clearable="false"
                      :options="types"
                      :reduce="item => item.value"
                      disabled
                      input-id="productType"
                      label="label"
                  />
                </b-form-group>
              </b-col>

              <b-col
                  cols="12"
                  md="4"
              >
                <b-form-group
                    label="دسته‌بندی خدمات"
                    label-for="serviceCategoryType"
                >
                  <v-select
                      v-model="product.serviceCategoryType"
                      :clearable="false"
                      :searchable="true"
                      :options="serviceCategoryTypes"
                      :reduce="item => item.value"
                      input-id="serviceCategoryType"
                      label="label"
                      placeholder="انتخاب دسته‌بندی خدمات"
                  >
                    <template #no-options>
                      گزینه‌ای پیدا نشد
                    </template>
                  </v-select>
                </b-form-group>
              </b-col>

              <b-col
                  v-if="Number(product.type) === 1"
                  cols="12"
                  md="4"
              >
                <b-form-group
                    label="انتخاب دوره"
                    label-for="courseId"
                >
                  <v-select
                      v-model="product.courseId"
                      :options="courses"
                      :reduce="item => item.courseId"
                      :clearable="false"
                      input-id="courseId"
                      label="name"
                      placeholder="انتخاب دوره"
                  />
                </b-form-group>
              </b-col>

              <b-col
                  v-if="Number(product.type) === 8"
                  cols="12"
              >
                <b-row>
                  <b-col
                      v-for="(item, index) in product.productInfos"
                      :key="index"
                      cols="12"
                  >
                    <b-row>
                      <b-col
                          cols="12"
                          md="8"
                      >
                        <b-form-group
                            :label="`توضیحات آیتم شماره ${index + 1}`"
                        >
                          <b-form-textarea
                              v-model="item.title"
                          />
                        </b-form-group>
                      </b-col>

                      <b-col
                          cols="12"
                          md="4"
                      >
                        <b-form-group
                            :label="`آیکون آیتم شماره ${index + 1}`"
                        >
                          <b-form-textarea
                              v-model="item.icon"
                          />
                        </b-form-group>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>

            <b-button
                type="submit"
                :block="$store.getters['app/currentBreakPoint'] === 'xs'"
                class="mt-1 mb-sm-0 mr-0 mr-sm-1 col-12 col-md-2"
                variant="primary"
                :disabled="showOverlay"
            >
              ثبت
            </b-button>
          </b-form>
        </b-tab>
      </b-tabs>
    </component>

    <b-card class="mt-5">
      <b-row>
        <b-col cols="12">
          <h2>ویرایش وضعیت موجودیت</h2>

          <b-row>
            <b-col
                cols="12"
                md="4"
            >
              <b-form-group
                  label="موجودیت"
                  label-for="isAvailable"
              >
                <v-select
                    v-model="isAvailable"
                    :clearable="false"
                    :options="isAvailableOptions"
                    :reduce="item => item.value"
                    input-id="isAvailable"
                    label="label"
                />
              </b-form-group>

              <b-button
                  variant="primary"
                  :disabled="showOverlay"
                  @click="changeProductAvailablity"
              >
                ویرایش وضعیت
              </b-button>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-card>

    <b-card class="mt-5">
      <b-row>
        <b-col cols="12">
          <h2>تریلر</h2>

          <b-row>
            <b-col
                v-if="!base64Trailer"
                cols="12"
            >
              <b-button
                  class="mt-2 col-6"
                  variant="warning"
                  @click="$refs.refInputEl2.click()"
              >
                <input
                    ref="refInputEl2"
                    class="d-none"
                    type="file"
                    accept="video/*"
                    @change="select"
                >

                <span>
                  {{ file ? file.name : "انتخاب تریلر" }}
                </span>
              </b-button>

              <b-button
                  :block="$store.getters['app/currentBreakPoint'] === 'xs'"
                  class="mt-2 mb-sm-0 ml-2 mr-sm-1 col-12 col-md-2"
                  variant="primary"
                  :disabled="!file || showOverlay"
                  @click="upload"
              >
                ثبت
              </b-button>

              <b-progress
                  v-if="uploaded !== 0 && uploaded !== 100"
                  :value="uploaded"
                  class="mt-2"
                  max="100"
                  variant="primary"
              />
            </b-col>

            <b-col
                v-else
                cols="12"
            >
              <video
                  class="col-10"
                  controls
                  style="max-height: 30rem"
              >
                <source :src="base64Trailer">
              </video>

              <b-button
                  :block="$store.getters['app/currentBreakPoint'] === 'xs'"
                  class="mt-1 mb-sm-0 ml-1 mr-sm-1 col-2 col-md-2"
                  variant="danger"
                  :disabled="showOverlay"
                  @click="deleteTrailer"
              >
                حذف تریلر
              </b-button>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-card>
  </b-overlay>
</template>

<script>
import TagPicker from "@/views/components/TagPicker.vue";
import {
  BAvatar,
  BButton,
  BCard,
  BCol,
  BForm,
  BFormCheckbox,
  BFormGroup,
  BFormInput,
  BFormTextarea,
  BMedia,
  BModal,
  BOverlay,
  BProgress,
  BRow,
  BTab,
  BTabs,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import vSelect from "vue-select";
import axios from "axios";
import { getUserData } from "@/auth/utils";
import Helper from "@/libs/Helper";
import ToastificationContent from "@core/components/toastification/ToastificationContent";
import ckEditorMain from "@/views/components/ckEditorMain";
import {
  ProductCategoryGetAllRequest,
  ProductChangeProductAvailablityRequest,
  ProductCourseGetAllRequest,
  ProductGetByIdRequest,
  ProductUpdateRequest,
} from "@/libs/Api/Product";
import {
  MediaDeleteMediaByPictureUrlRequest,
} from "@/libs/Api/Media";

import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

export default {
  name: "ProductEdit",

  title: "اطلاعات محصول - پنل ادمین بنفشه باقری",

  components: {
    TagPicker,
    BAvatar,
    BButton,
    BCard,
    BCol,
    BForm,
    BFormCheckbox,
    BFormGroup,
    BFormInput,
    BFormTextarea,
    BMedia,
    BModal,
    BOverlay,
    BProgress,
    BRow,
    BTab,
    BTabs,
    vSelect,
    ckEditorMain,
  },

  directives: {
    Ripple,
  },

  data() {
    return {
      product: null,
      showOverlay: false,
      productId:
          this.$route.params.id ||
          this.$route.path.split("/")[3],
      base64ImageSrc: null,
      categories: null,
      courses: [],
      showHTML: false,
      rawHTML: "",
      base64Trailer: null,
      isAvailable: null,
      userToken: getUserData().token,
      file: null,
      uploaded: 0,
      isFreeOptions: [
        {
          label: "رایگان",
          value: true,
        },
        {
          label: "پولی",
          value: false,
        },
      ],
      types: [
        {
          label: "دوره",
          value: 1,
        },
        {
          label: "فیلم",
          value: 2,
        },
        {
          label: "فایل",
          value: 3,
        },
        {
          label: "پادکست",
          value: 4,
        },
        {
          label: "پکیج",
          value: 7,
        },
        {
          label: "تست روانشناسی",
          value: 8,
        },
      ],
      serviceCategoryTypes: [
        {
          label: "بهبود رابطه با پارتنر",
          value: 1,
        },
        {
          label: "پیش‌گیری از خیانت",
          value: 2,
        },
        {
          label: "جذابیت‌های زنانه در رابطه عاطفی",
          value: 3,
        },
        {
          label: "فرزندپروری",
          value: 4,
        },
        {
          label: "آموزش‌های سواد رابطه جنسی",
          value: 5,
        },
      ],
      isAvailableOptions: [
        {
          label: "موجود",
          value: true,
        },
        {
          label: "ناموجود",
          value: false,
        },
      ],
    };
  },

  computed: {
    formData() {
      const formData = new FormData();

      if (this.file) {
        formData.set(
            "file",
            this.file,
            this.file.name
        );
      }

      return formData;
    },

    uploadConfig() {
      return {
        method: "POST",
        data: this.formData,
        withCredentials: true,
        url:
            `${Helper.baseUrl}api/Product/UploadTrailer` +
            `?productId=${this.product.productId}`,
        headers: {
          Authorization: `Bearer ${this.userToken}`,
          "Content-Type": "multipart/form-data",
        },
        onUploadProgress: (progressEvent) => {
          if (!progressEvent.total) {
            return;
          }

          this.uploaded = Math.round(
              (progressEvent.loaded * 100) /
              progressEvent.total
          );
        },
      };
    },
  },

  async created() {
    await this.getProduct();
    await this.getAllProductCategories();
    await this.getAllCourses();
  },

  methods: {
    fetchRequest(request) {
      return new Promise((resolve, reject) => {
        try {
          request.fetch(resolve, reject);
        } catch (error) {
          reject(error);
        }
      });
    },

    showToast(
        title,
        text,
        variant = "success",
        icon = "CheckIcon"
    ) {
      this.$toast({
        component: ToastificationContent,
        position: "bottom-center",
        props: {
          title,
          icon,
          variant,
          text,
        },
      });
    },

    getErrorMessage(error, fallback) {
      return (
          error?.response?.data?.errorMessage ||
          error?.response?.data?.message ||
          error?.message ||
          fallback
      );
    },

    getFileUrl(path) {
      if (!path) {
        return null;
      }

      const value = String(path).trim();

      if (
          value.startsWith("http://") ||
          value.startsWith("https://") ||
          value.startsWith("blob:") ||
          value.startsWith("data:")
      ) {
        return value;
      }

      const baseUrl = String(
          Helper.baseUrl || ""
      ).replace(/\/+$/, "");

      const normalizedPath =
          value.replace(/^\/+/, "");

      return `${baseUrl}/${normalizedPath}`;
    },

    async getProduct() {
      this.showOverlay = true;

      const request =
          new ProductGetByIdRequest(this);

      request.setId(this.productId);

      try {
        const content =
            await this.fetchRequest(request);

        const responseProduct =
            content?.product || null;

        if (!responseProduct) {
          throw new Error(
              "اطلاعات محصول دریافت نشد."
          );
        }

        const serviceCategoryType =
            Number(
                responseProduct.serviceCategoryType
            );

        this.product = {
          ...responseProduct,
          tagIds: (responseProduct.tags || []).map(tag => tag.tagId),
          sliderTagIds: (responseProduct.sliderTags || []).map(tag => tag.tagId),
          imageFile: "",
          trailerFile: "",
          taxServiceType: 3,
          serviceCategoryType:
              [1, 2, 3, 4, 5].includes(
                  serviceCategoryType
              )
                  ? serviceCategoryType
                  : 1,
          productInfos: Array.isArray(
              responseProduct.productInfos
          )
              ? responseProduct.productInfos
              : [],
        };


        this.base64ImageSrc =
            this.getFileUrl(
                responseProduct.imageFile
            );

        if (
            responseProduct.trailerFile &&
            responseProduct.trailerFile !==
            "media/gallery/Trailer/"
        ) {
          this.base64Trailer =
              this.getFileUrl(
                  responseProduct.trailerFile
              );
        } else {
          this.base64Trailer = null;
        }

        this.isAvailable =
            Boolean(responseProduct.available);

        this.rawHTML =
            responseProduct.description || "";
      } catch (error) {
        console.error(error);

        this.product = null;

        this.showToast(
            "عملیات ناموفق",
            this.getErrorMessage(
                error,
                "دریافت اطلاعات محصول انجام نشد."
            ),
            "danger",
            "CloseIcon"
        );
      } finally {
        this.showOverlay = false;
      }
    },

    async getAllProductCategories() {
      this.showOverlay = true;

      const request =
          new ProductCategoryGetAllRequest(
              this
          );

      request.setParams({
        pageNumber: 0,
        count: 0,
      });

      try {
        const content =
            await this.fetchRequest(request);

        this.categories =
            Array.isArray(
                content?.productCategories
            )
                ? content.productCategories
                : [];
      } catch (error) {
        console.error(error);

        this.categories = [];

        this.showToast(
            "عملیات ناموفق",
            this.getErrorMessage(
                error,
                "دریافت دسته‌بندی‌ها انجام نشد."
            ),
            "danger",
            "CloseIcon"
        );
      } finally {
        this.showOverlay = false;
      }
    },

    async getAllCourses() {
      this.showOverlay = true;

      const request =
          new ProductCourseGetAllRequest(this);

      request.setParams({
        pageNumber: 0,
        searchCommand: "",
        count: 0,
      });

      try {
        const content =
            await this.fetchRequest(request);

        this.courses =
            Array.isArray(content?.courses)
                ? content.courses
                : [];
      } catch (error) {
        console.error(error);

        this.courses = [];

        this.showToast(
            "عملیات ناموفق",
            this.getErrorMessage(
                error,
                "دریافت دوره‌ها انجام نشد."
            ),
            "danger",
            "CloseIcon"
        );
      } finally {
        this.showOverlay = false;
      }
    },

    async updateProduct() {
      if (
          !this.product ||
          this.showOverlay
      ) {
        return;
      }

      const serviceCategoryType =
          Number(
              this.product.serviceCategoryType
          );

      if (
          ![1, 2, 3, 4, 5].includes(
              serviceCategoryType
          )
      ) {
        this.showToast(
            "عملیات ناموفق",
            "دسته‌بندی خدمات را انتخاب کنید.",
            "danger",
            "CloseIcon"
        );

        return;
      }

      this.showOverlay = true;

      const productPayload = {
        ...this.product,
      };

      delete productPayload.seoTitle;
      delete productPayload.seoUrl;
      delete productPayload.seoDescription;
      delete productPayload.seoKeywords;

      const payload = {
        ...productPayload,
        productId:
            Number(this.product.productId),
        courseId:
            this.product.courseId
                ? Number(this.product.courseId)
                : null,
        productCategoryId:
            this.product.productCategoryId
                ? Number(
                    this.product
                        .productCategoryId
                )
                : null,
        type: Number(this.product.type),
        taxServiceType: 3,
        serviceCategoryType,
        trailerFile: "",
      };

      const request =
          new ProductUpdateRequest(this);

      request.setParams(payload);

      try {
        const content =
            await this.fetchRequest(request);

        if (
            content &&
            content.isSuccess === false
        ) {
          throw new Error(
              content.errorMessage ||
              "ویرایش محصول انجام نشد."
          );
        }

        this.showToast(
            "عملیات موفق",
            "اطلاعات محصول با موفقیت ویرایش شد."
        );

        await this.getProduct();
      } catch (error) {
        console.error(error);

        this.showToast(
            "عملیات ناموفق",
            this.getErrorMessage(
                error,
                "ویرایش محصول انجام نشد."
            ),
            "danger",
            "CloseIcon"
        );
      } finally {
        this.showOverlay = false;
      }
    },

    async changeProductAvailablity() {
      if (
          !this.productId ||
          this.showOverlay
      ) {
        return;
      }

      this.showOverlay = true;

      const request =
          new ProductChangeProductAvailablityRequest(
              this
          );

      request.setParams({
        productId:
            Number(this.productId),
        isAvailable:
            Boolean(this.isAvailable),
      });

      try {
        const content =
            await this.fetchRequest(request);

        if (
            content &&
            content.isSuccess === false
        ) {
          throw new Error(
              content.errorMessage ||
              "ویرایش وضعیت انجام نشد."
          );
        }

        this.showToast(
            "عملیات موفق",
            "وضعیت موجودی ویرایش شد."
        );

        await this.getProduct();
      } catch (error) {
        console.error(error);

        this.showToast(
            "عملیات ناموفق",
            this.getErrorMessage(
                error,
                "ویرایش وضعیت انجام نشد."
            ),
            "danger",
            "CloseIcon"
        );
      } finally {
        this.showOverlay = false;
      }
    },

    readAsDataURL(file) {
      return new Promise(
          (resolve, reject) => {
            const reader =
                new FileReader();

            reader.onerror = reject;

            reader.onload = () => {
              const result = String(
                  reader.result || ""
              );

              resolve(
                  result.includes(",")
                      ? result.split(",")[1]
                      : result
              );
            };

            reader.readAsDataURL(file);
          }
      );
    },

    async makeBase64Pic(event) {
      const file =
          event.target.files &&
          event.target.files[0];

      if (
          !file ||
          !this.product
      ) {
        return;
      }

      this.base64ImageSrc =
          URL.createObjectURL(file);

      this.product.imageFile =
          await this.readAsDataURL(file);
    },

    deleteProductPic() {
      if (!this.product) {
        return;
      }

      this.product.imageFile = "";
      this.base64ImageSrc = null;
    },

    select(event) {
      const file =
          event.target.files &&
          event.target.files[0];

      this.file = file || null;
      this.uploaded = 0;
    },

    async upload() {
      if (
          !this.file ||
          !this.product ||
          this.showOverlay
      ) {
        return;
      }

      this.showOverlay = true;

      try {
        const response =
            await axios(
                this.uploadConfig
            );

        if (
            response?.data &&
            response.data.isSuccess === false
        ) {
          throw new Error(
              response.data.errorMessage ||
              "آپلود تریلر انجام نشد."
          );
        }

        this.uploaded = 100;
        this.file = null;

        if (this.$refs.refInputEl2) {
          this.$refs.refInputEl2.value =
              "";
        }

        this.showToast(
            "عملیات موفق",
            "تریلر با موفقیت آپلود شد."
        );

        await this.getProduct();
      } catch (error) {
        console.error(error);

        this.uploaded = 0;

        this.showToast(
            "عملیات ناموفق",
            this.getErrorMessage(
                error,
                "آپلود تریلر انجام نشد."
            ),
            "danger",
            "CloseIcon"
        );
      } finally {
        this.showOverlay = false;
      }
    },

    async deleteTrailer() {
      if (
          !this.base64Trailer ||
          this.showOverlay
      ) {
        return;
      }

      const marker =
          "media/gallery/Trailer/";

      const markerIndex =
          this.base64Trailer.indexOf(
              marker
          );

      const pictureUrl =
          markerIndex >= 0
              ? this.base64Trailer.substring(
                  markerIndex +
                  marker.length
              )
              : "";

      if (!pictureUrl) {
        this.showToast(
            "عملیات ناموفق",
            "آدرس تریلر معتبر نیست.",
            "danger",
            "CloseIcon"
        );

        return;
      }

      this.showOverlay = true;

      const request =
          new MediaDeleteMediaByPictureUrlRequest(
              this
          );

      request.setParams({
        pictureUrl,
      });

      try {
        const content =
            await this.fetchRequest(request);

        if (
            content &&
            content.isSuccess === false
        ) {
          throw new Error(
              content.errorMessage ||
              "حذف تریلر انجام نشد."
          );
        }

        this.base64Trailer = null;

        this.showToast(
            "عملیات موفق",
            "تریلر با موفقیت حذف شد."
        );

        await this.getProduct();
      } catch (error) {
        console.error(error);

        this.showToast(
            "عملیات ناموفق",
            this.getErrorMessage(
                error,
                "حذف تریلر انجام نشد."
            ),
            "danger",
            "CloseIcon"
        );
      } finally {
        this.showOverlay = false;
      }
    },

    customButtonClick() {
      if (!this.product) {
        return;
      }

      if (this.showHTML) {
        this.product.description =
            this.rawHTML;
      } else {
        this.rawHTML =
            this.product.description || "";
      }

      this.showHTML = !this.showHTML;
    },

    setEditorContent(content) {
      if (!this.product) {
        return;
      }

      this.product.description =
          content;

      this.rawHTML =
          content || "";
    },
  },
};
</script>

<style lang="scss">
@import "~@core/scss/base/pages/app-ecommerce-details.scss";

</style>
